import { Outlet, useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { ConversationsList } from './ConversationsList'

const MessagesInboxPage = () => {
  const params = useParams()
  const conversationId = String(params.conversation_id)

  useUnsafeEffect(() => {
    track(trackingEvents.ats.goToMessageInbox)
  }, [])

  return (
    <Box flexGrow position="relative">
      <Box
        padding="s24"
        flexDirection="row"
        position="absolute"
        style={{
          inset: '0px',
        }}
      >
        <ConversationsList />
        <Box alignItems="center" flexGrow>
          <Outlet context={{ conversationId }} />
        </Box>
      </Box>
    </Box>
  )
}

export default MessagesInboxPage
